

import Vue from 'vue'
import App from './App'
import router from './router'

import './assets/css/font.css'                              
import './assets/css/common.css'                          
import './assets/css/transition.css'                      
import './assets/iconfont/iconfont.css'                   
import './assets/iconfonth5/iconfont.css'                 
import './assets/css/vux.less'                             

import beforeEach from './router/route-hook/beforeEach'   
import afterEach from './router/route-hook/afterEach'     
import store from './store'                               
import $config from './assets/config'                     
import * as $utils from './assets/js/utils'               
import * as $api from './assets/api/index'                   
import Calendar from 'vue-mobile-calendar'
import VueScroller from 'vue-scroller'
import $constant from '@assets/js/constant.js'
import i18n from './assets/locale/'
import vFilter from './filters'                           
import LeonPlugin from './plugin'                         
import LeonInstruction from './instruction'               
import AlertBox from './components/common/alert-box'      
import myMixin from './mixin/common/index'
import animated from 'animate.css'
import 'vant/lib/icon/style'
import {Icon} from 'vant'
import vuePicturePreview from 'vue-picture-preview'
import VueViewer  from 'v-viewer'
import NoSleep from 'nosleep.js/dist/NoSleep.min.js'
import 'viewerjs/dist/viewer.css'
import Previewer from 'vux/src/components/previewer/index.vue'


Vue.use(VueViewer)
Vue.use(Previewer)
Vue.use(animated)
Vue.use(Icon)
Vue.use(vuePicturePreview)





Vue.component('alert-box', AlertBox)
Vue.prototype.$utils = $utils
Vue.prototype.$api = $api
Vue.prototype.$config = $config
Vue.prototype.$constant = $constant
Vue.prototype.$NoSleep = NoSleep

Vue.prototype.$EventBus = new Vue()














router.beforeEach((to, from, next) => { // 跳转路由前公共钩子函数
beforeEach(to, from, next)
})
router.afterEach((to, from, next) => {  // 跳转路由后公共钩子函数
afterEach(to, from, next)
})

Vue.prototype.appUserAgent = $utils.getUserAgent()   

Vue.config.productionTip = false

Vue.use(vFilter)              
Vue.use(LeonPlugin)           
Vue.use(LeonInstruction)      
Vue.use(Calendar)             
Vue.use(VueScroller)          
Vue.use(myMixin)              



Vue.mixin({
watch: {
'login_bol' () {
if (this.login_bol) {
typeof this.init === 'function' && this.init()
}
}
}
})

Vue.config.ignoredElements = ['wx-open-launch-weapp']

/* eslint-disable no-new */
new Vue({
el: '#app',
store,
i18n,
router,
components: { App },
template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js